export default "__VITE_ASSET__7$l99RZj__"